import { render, staticRenderFns } from "./user-items.vue?vue&type=template&id=74e1f92f&scoped=true&"
import script from "./user-items.vue?vue&type=script&lang=js&"
export * from "./user-items.vue?vue&type=script&lang=js&"
import style0 from "./user-items.vue?vue&type=style&index=0&id=74e1f92f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e1f92f",
  null
  
)

export default component.exports